// @ts-check

/**
 * @file Renders the system-test blank route.
 */
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import {View} from "react-native-propforge"
import ScreenTitle from "../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @type {Record<string, object>} */
const styles = {}

/** @typedef {{[key: string]: unknown}} BlankScreenProps */

/** @typedef {Record<string, never>} BlankScreenState */

/**
 * Blank route used by the system-testing runner as its initial idle page.
 * @augments {ShapeComponent<BlankScreenProps, BlankScreenState>}
 */
class BlankScreen extends ShapeComponent {
  /**
   * Renders the blank route marker.
   * @returns {ReactNode} Blank route content.
   */
  render() {
    return (
      <View
        style={styles.blankScreen ||= {
          flex: 1
        }}
        testID="blankScreen"
      >
        <ScreenTitle>{"Blank"}</ScreenTitle>
        {/* system-testing waits on blankText as its ready marker; it needs
            presence, not text content, so keep this element visually empty
            so `blank-route-spec` can assert blankScreen has no visible text. */}
        <View
          style={styles.blankTextMarker ||= {
            height: 1,
            width: 1
          }}
          testID="blankText"
        />
      </View>
    )
  }
}

/** @type {NamedExoticComponent<BlankScreenProps>} */
const BlankScreenComponent = memo(shapeComponent(BlankScreen))

export default BlankScreenComponent
